<span class="logout" (click)="logout()">{{ 'profile.logoutFromAccount' | translate }}</span>
